export const parseJson = (value: string) => {
    try {
        return JSON.parse(value);
    } catch (e) {
        return null;
    }
};
